import { DatePicker } from "@/shared/components/common/DatePicker/DatePicker"
import { useDateEnd } from "./useDateEnd"

function DateEnd() {
  
  const { value, setValue, pickerType, setPickerType } = useDateEnd();

  return (
    <DatePicker
      value={value}
      onChange={setValue}
      placeholder="Дата окончания периода"
      pickerType={pickerType}
      onPickerTypeChange={setPickerType}
    />
  )
}

export default DateEnd